<template>
  <div class="rounded bg-grey_3 pa-3 mb-4 bordered">
    <div class="text-h5 mb-4 font-weight-bold">
      {{ activite.nom }}
      <v-chip color="primary-dark" variant="elevated" elevation="0" density="compact">{{ activite.nb_inscrits }} inscrits</v-chip>
    </div>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="activite.nom" label="Nom de l'activité"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="activite.prix" type="number" label="Prix" append-inner-icon="mdi-currency-eur"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-switch v-model="activite.obligatoire" hide-details true-value="1" false-value="0" :label="activite.obligatoire == '1' ? 'Activité obligatoire' : 'Activité facultative'" color="green" inset></v-switch>
      </v-col>
      <v-col cols="12" md="6">
        <v-switch v-model="activite.visible_accueil" hide-details true-value="1" false-value="0" :label="activite.visible_accueil == '1' ? 'Visible sur l\'accueil' : 'Masquée sur l\'accueil'" color="green" inset></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="activite.date_min" type="date" label="Date d'ouverture"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="activite.date_max" type="date" label="Date de fermeture"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field v-model="activite.quantite" type="number" :disabled="is_quantite_disabled" label="Quantité max (0 si pas de limite)"></v-text-field>
      </v-col>
      <v-col cols="12" md="6" v-if="is_quantite_disabled">
        <v-alert border="start" border-color="red" density="compact">La modification de ce champ a des répercussions sur d'autres paramètres du module d'inscription. Veuillez contacter yann@sportips.fr</v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Activite from "@/classes/Activites/Activite.class";

export default {
  props: ["item"],
  data() {
    return {
      activite: new Activite(),
    };
  },
  computed: {
    is_quantite_disabled() {
      return !this.activite.is_quantite_editable();
    },
  },
  mounted() {
    this.activite = this.item;
  },
};
</script>

<style lang="scss" scoped></style>
